import React, { useState, useEffect } from "react";
import "../assets/css/team.scss";
import LeftSideEditProfile from "./../LeftSideEditProfile";
import { Title } from "./../videoPhoto/Component";
import VerificationIcon from "./../assets/img/complete-verification-icon.svg";
import FormControl from "@mui/material/FormControl";
import { ListSubheader, MenuItem, Select } from "@mui/material";
import {
  AplhaNumericInput,
  AplhaNumericInputComma,
  validURL,
} from "../../../../../../utils/validationUtils";
import { countryListStart } from "../../../../../../redux/common/countriesList";
import { stateListStart } from "../../../../../../redux/common/allStates";
import {Link, useHistory} from "react-router-dom";
import {
  organizationsListStart,
  organizationsSaveStart,
} from "../../../../../../redux/common/allOrganizationsList";
import { categoriesListStart } from "../../../../../../redux/common/allCatergoriesList";
import {
  getAllOrganizationsQuery,
  getAllCountriesQuery,
} from "../../../../../common/CommonQuery";
import {connect, useDispatch, useSelector} from "react-redux";
import BackdropLoader from "../../../../../common/Loader";
import MuiAutoComplete from "../../../../../common/AutoComplete";
import { getAllEventCatergoriesQuery } from "../../../../../common/CommonQuery";
import { allTeamsListStart } from "../../../../../../redux/athlete/dashboard/editUserProfile/allTeams";
import {
  getAllTeamsNameQuery,
  saveAddEditEventFormData,
  getAllAddEditFormDataQuery,
  saveAllOrganizationsData,
  getAllStatesCountries,
  saveAllTeamsDataQuery,
  saveAddedEventQuery,
  getAllAddedEventsQuery
} from "./AddEditEventFormQuery";
import {
  addEditEventFormListStart,
} from "../../../../../../redux/athlete/dashboard/editUserProfile/addEditEventForm";
import { getUserInfo } from "../../../../../../services/authService";
import {
  fetchGraphMethod,
  fetchMethod,
} from "../../../../../../services/httpService";
import AutoCompleteCitySearch from "../../../../../common/AutoCompleteCitySearch";
import messagePopup from "../../../../../../utils/messagePopup";
import {styleSheet} from "../../../../../common/styleLabel";
import toastr from 'toastr';

const SubHeader = ({ onSideMenuClick }) => {
  return (
    <div className="subHeader">
      <div className="menu">
        <button onClick={onSideMenuClick}>
          <span></span> Edit Profile
        </button>
      </div>
      {JSON.parse(localStorage.getItem('user')).verifiedUserStatus === 1 ?
        <div className="profile-verified-text">
          <span className="verifiedIcon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="26.418"
              height="26.403"
              viewBox="0 0 26.418 26.403"
            >
              <defs>
                <style></style>
              </defs>
              <path
                className="a"
                d="M-4229.021-6663.778a1.151,1.151,0,0,1-.986-.543,1.174,1.174,0,0,0-.993-.543,1.174,1.174,0,0,0-.993.543,1.151,1.151,0,0,1-.986.543,1.169,1.169,0,0,1-1.152-.9v-.005a1.179,1.179,0,0,0-1.149-.9,1.16,1.16,0,0,0-.728.256,1.169,1.169,0,0,1-.729.259,1.2,1.2,0,0,1-.883-.392,1.158,1.158,0,0,1-.3-.9l0-.013a1.161,1.161,0,0,0-.3-.9,1.184,1.184,0,0,0-.87-.387,1.181,1.181,0,0,0-.395.068h-.005a1.189,1.189,0,0,1-.4.07,1.175,1.175,0,0,1-.984-.544,1.155,1.155,0,0,1-.084-1.116l.01-.021a1.174,1.174,0,0,0-.088-1.121,1.175,1.175,0,0,0-.989-.538h-.033a1.163,1.163,0,0,1-1.08-.708,1.164,1.164,0,0,1,.219-1.274l.019-.019a1.171,1.171,0,0,0,.28-1.09,1.176,1.176,0,0,0-.769-.831l-.02,0a1.164,1.164,0,0,1-.8-1.02,1.164,1.164,0,0,1,.621-1.138l.02-.01a1.174,1.174,0,0,0,.621-.943,1.172,1.172,0,0,0-.456-1.031l-.02-.017a1.161,1.161,0,0,1-.425-1.223,1.164,1.164,0,0,1,.957-.875l.017,0a1.174,1.174,0,0,0,.894-.688,1.172,1.172,0,0,0-.1-1.125l-.013-.021a1.159,1.159,0,0,1-.058-1.2,1.173,1.173,0,0,1,1.03-.625,1.229,1.229,0,0,1,.215.019h.008a1.234,1.234,0,0,0,.21.019,1.166,1.166,0,0,0,.928-.459,1.169,1.169,0,0,0,.207-1.017l0-.017a1.148,1.148,0,0,1,.2-1.012,1.2,1.2,0,0,1,.938-.467,1.169,1.169,0,0,1,.572.151,1.16,1.16,0,0,0,.571.15,1.186,1.186,0,0,0,1.177-1.092v-.01a1.176,1.176,0,0,1,1.184-1.092,1.158,1.158,0,0,1,.866.39,1.159,1.159,0,0,0,.871.39,1.18,1.18,0,0,0,1.086-.715,1.162,1.162,0,0,1,1.084-.717,1.162,1.162,0,0,1,1.084.715,1.18,1.18,0,0,0,1.086.717,1.159,1.159,0,0,0,.871-.39,1.158,1.158,0,0,1,.866-.39,1.176,1.176,0,0,1,1.184,1.092v.01a1.186,1.186,0,0,0,1.177,1.092,1.16,1.16,0,0,0,.569-.148,1.164,1.164,0,0,1,.574-.153,1.2,1.2,0,0,1,.938.467,1.148,1.148,0,0,1,.2,1.012l-.005.017a1.169,1.169,0,0,0,.207,1.017,1.166,1.166,0,0,0,.928.459,1.234,1.234,0,0,0,.21-.019h.008a1.229,1.229,0,0,1,.215-.019,1.172,1.172,0,0,1,1.029.625,1.158,1.158,0,0,1-.057,1.2l-.013.021a1.172,1.172,0,0,0-.1,1.125,1.174,1.174,0,0,0,.894.688l.017,0a1.164,1.164,0,0,1,.958.875,1.161,1.161,0,0,1-.425,1.222l-.021.017a1.173,1.173,0,0,0-.456,1.032,1.174,1.174,0,0,0,.621.943l.021.01a1.164,1.164,0,0,1,.621,1.138,1.164,1.164,0,0,1-.8,1.02l-.02,0a1.179,1.179,0,0,0-.769.831,1.171,1.171,0,0,0,.283,1.09l.016.019a1.164,1.164,0,0,1,.218,1.273,1.163,1.163,0,0,1-1.08.708h-.033a1.175,1.175,0,0,0-.989.538,1.174,1.174,0,0,0-.088,1.121l.01.021a1.154,1.154,0,0,1-.083,1.116,1.175,1.175,0,0,1-.984.544,1.185,1.185,0,0,1-.4-.07h-.005a1.181,1.181,0,0,0-.395-.068,1.184,1.184,0,0,0-.87.387,1.161,1.161,0,0,0-.3.9v.013a1.157,1.157,0,0,1-.3.9,1.2,1.2,0,0,1-.883.392,1.159,1.159,0,0,1-.727-.259,1.164,1.164,0,0,0-.729-.256,1.181,1.181,0,0,0-1.15.9v0A1.168,1.168,0,0,1-4229.021-6663.778Zm-7.2-15.261a.709.709,0,0,0-.522.232l-1.041,1.122a.835.835,0,0,0,0,1.12l4.787,5.15a.712.712,0,0,0,.522.231.71.71,0,0,0,.52-.231l8.471-9.111a.84.84,0,0,0,0-1.122l-1.041-1.12a.711.711,0,0,0-.522-.232.705.705,0,0,0-.521.232l-6.908,7.43-3.226-3.469A.706.706,0,0,0-4236.221-6679.039Z"
                transform="translate(4244.209 6690.181)"
              />
            </svg>
          </span>
          Congrats your profile is verified
        </div>
        : <div className="profile-verified-text">
          <img
            className="icon"
            src={VerificationIcon}
            alt="Verified"
          />
          Your profile is not verified for college coaches.
          <a style={{"cursor":"pointer"}} onClick={()=>window.open('https://calendly.com/sportsforce/recruiting-assessment-round-robin','_blank')}>Complete Verification Now</a>
        </div>}
      <div className="save">
        {/* <button>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13.889"
            height="13.945"
            viewBox="0 0 13.889 13.945"
          >
            <g id="save" transform="translate(0 -0.001)">
              <path
                id="Path_2125"
                data-name="Path 2125"
                d="M13.38,2.1,11.793.508A1.736,1.736,0,0,0,10.565,0H9.548V3.038a.434.434,0,0,1-.434.434H2.17a.434.434,0,0,1-.434-.434V0H.868A.868.868,0,0,0,0,.868V13.021a.868.868,0,0,0,.868.868H13.021a.868.868,0,0,0,.868-.868v-9.7A1.736,1.736,0,0,0,13.38,2.1ZM12.153,12.153H1.736V6.944H12.153Z"
                transform="translate(0 0.058)"
                fill="#3e3e3e"
              />
              <rect
                id="Rectangle_416"
                data-name="Rectangle 416"
                width="2"
                height="3"
                transform="translate(5.457 0.001)"
                fill="#3e3e3e"
              />
            </g>
          </svg>
          Save
        </button> */}
      </div>
    </div>
  );
};

const SelectBox = () => {
  const onChange = () => { };
  return (
    <FormControl variant="outlined" fullWidth>
      <Select onChange={onChange} id="select1" label="Select">
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        <MenuItem key={"index"} value={"Select"}>
          {"Select"}
        </MenuItem>
      </Select>
    </FormControl>
  );
};

const EditSection = (props) => {
  const [fields, setFields] = useState({
    category: "",
    startDate: "",
    endDate: "",
    eventName: props.eventName ? props.eventName : "",
    divisionLevel: "",
    location: "",
    city: props.city ? props.city : "",
    state: props.state ? props.state : "",
    country: "",
    countryId: "",
    websiteURL: "",
    eventNotes: "",
    eventOrganisation: props.eventOrgName ?? "",
    eventOrgName: "",
    teamName: "",
    eventTeamName: "",
    eventId: "",
  });
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState({});
  let history = useHistory();
  const [eventOrganisationArray, setEventOrganisationArray] = useState([]);
  const [teamProgramArray, setTeamProgramArray] = useState([]);
  const [organisationId, setOrganisationId] = useState("");
  //for progress bar
  const dispatch = useDispatch()
  useEffect(() => {
    const editEventId = window.location.href.split("/")[5];//$ earlier it was 6
    if (editEventId != 0) {
      const singleEventData =
        props.singleData &&
          props.singleData.data &&
          props.singleData.data.data &&
          props.singleData.data.data.allEvents != undefined &&
          props.singleData.data.data.allEvents.Events
          ? props.singleData.data.data.allEvents.Events
          : "";
      if (singleEventData && singleEventData.length) {
        let fieldsT = fields;
        fieldsT["eventId"] =
          singleEventData ? singleEventData[0]?.id
            : null;
        fieldsT["category"] = singleEventData
          ? singleEventData[0].categoryid
          : null;
        fieldsT["startDate"] = singleEventData
          ? singleEventData[0].startdate
          : "";
        fieldsT["endDate"] = singleEventData ? singleEventData[0].enddate : "";
        fieldsT["eventName"] = singleEventData
          ? singleEventData[0].eventname
          : "";
        fieldsT["divisionLevel"] = singleEventData
          ? singleEventData[0].divisionorlevel
          : "";
        fieldsT["location"] = singleEventData
          ? singleEventData[0].location
          : "";
        fieldsT["city"] = singleEventData ? singleEventData[0].city : "";
        fieldsT["state"] =
          singleEventData &&
            singleEventData[0].eventstateidrel &&
            singleEventData[0].eventstateidrel.States &&
            singleEventData[0].eventstateidrel.States &&
            singleEventData[0].eventstateidrel.States[0] &&
            singleEventData[0].eventstateidrel.States[0] &&
            singleEventData[0].eventstateidrel.States[0].id
            ? singleEventData[0].eventstateidrel.States[0].id
            : "";
        fieldsT["country"] =
          singleEventData &&
            singleEventData[0].eventcountryidrel &&
            singleEventData[0].eventcountryidrel.Countries &&
            singleEventData[0].eventcountryidrel.Countries[0] &&
            singleEventData[0].eventcountryidrel.Countries[0].countryname
            ? singleEventData[0].eventcountryidrel.Countries[0].countryname
            : "";
        fieldsT["countryId"] =
          singleEventData &&
            singleEventData[0].eventcountryidrel &&
            singleEventData[0].eventcountryidrel.Countries &&
            singleEventData[0].eventcountryidrel.Countries[0] &&
            singleEventData[0].eventcountryidrel.Countries[0].id
            ? singleEventData[0].eventcountryidrel.Countries[0].id
            : "";
        fieldsT["eventOrganisation"] =
          singleEventData &&
            singleEventData[0].eventeventorgidrel &&
            singleEventData[0].eventeventorgidrel.Organizations &&
            singleEventData[0].eventeventorgidrel.Organizations[0] &&
            singleEventData[0].eventeventorgidrel.Organizations[0].eventorgname
            ? singleEventData[0].eventeventorgidrel.Organizations[0]
            : "";

        fieldsT["teamName"] =
          singleEventData &&
            singleEventData[0].eventteamidrel &&
            singleEventData[0].eventteamidrel.Teams &&
            singleEventData[0].eventteamidrel.Teams[0] &&
            singleEventData[0].eventteamidrel.Teams[0].teamname
            ? singleEventData[0].eventteamidrel.Teams[0]
            : "";

        fieldsT["websiteURL"] = singleEventData
          ? singleEventData[0].eventwebsiteurl
          : "";
        fieldsT["isverified"] = singleEventData
          ? singleEventData[0].isverified
          : "";
        fieldsT["eventNotes"] = singleEventData
          ? singleEventData[0].eventnotes
          : "";
        setFields({ ...fieldsT });
      }
    }
  }, [props.singleData]);
  //this is added when we come from search event page to make the form
  useEffect(()=>{
    if (!!props?.state && props?.data?.allCountries?.data?.length > 0 && props?.data?.allStates?.data?.length > 0){
      getCountryId()
    }
  },[props?.data?.allCountries, props?.data?.allStates])

  useEffect(() => {
    if (
      props.data &&
      props.data.teamList &&
      props.data.teamList.data &&
      props.data.teamList.data.allTeamsList != ""
    ) {
      setTeamProgramArray(props.data.teamList.data.allTeamsList);
    }
  }, [props.data.teamList.data]);

  useEffect(() => {
    if (
      props.data &&
      props.data.allOrganizations &&
      props.data.allOrganizations.data &&
      props.data.allOrganizations.data.data &&
      props.data.allOrganizations.data.data.allOrganizations &&
      props.data.allOrganizations.data.data.allOrganizations.Organizations != ""
    )
      setEventOrganisationArray(
        props.data.allOrganizations.data.data.allOrganizations.Organizations
      );
  }, [props.data.allOrganizations]);

  const handleChange = (e, field) => {
    if(field == "startDate" || field == "endDate"){
      const splitDate = !!e?.target?.value ? e?.target?.value?.split("-") : []
      if(splitDate?.length > 0 && splitDate?.[0]?.length > 4) return
    }
    setErrors({
      errorsT: "",
    });
    let fieldsT = fields;
    fieldsT[field] = e ? (e.target ? e.target.value : e) : e;
    if (fields.eventNotes.length > 200) {
      let errorsT = errors;
      errorsT["eventNotes"] = "Event notes can't be more than 200 characters";
      setErrors({
        ...errorsT,
      });
    }
    setFields({
      ...fieldsT,
    });
  };

  const getCountryId = () => {
    const countryID =
      props.data && props.data.allStates && props.data.allStates.data
        ? props.data.allStates.data.filter((item) => item.id === fields.state)
        : "";
    const countryName =
      props.data && props.data.allCountries && props.data.allCountries.data
        ? props.data.allCountries.data.filter(
          (item) => item.id === countryID[0].countryid
        )
        : null;
    let fieldsT = fields;
    fields["country"] = countryName[0].countryName;
    fieldsT["countryId"] = countryName[0].id;
    setFields({
      ...fieldsT,
    });
  };

  const handleValidation = (fieldname, e, setError) => {
    let errorsT = errors;
    let formIsValid = true;
    let fieldValue = e ? (e.target ? e.target.value : e) : e;
    let updatedValue = fieldValue;

    //location validations
    if (fieldname === undefined || fieldname === "location") {
      if (fieldname === undefined) {
        fieldValue = fields["location"] ? fields["location"] : "";
        updatedValue = fieldValue;
      }
      delete errorsT["location"];
      if (!updatedValue) {
        // formIsValid = true;
        errorsT["location"] = "";
      } else if (!AplhaNumericInput(updatedValue)) {
        formIsValid = false;
        errorsT["location"] = "No Special Characters Allowed";
      }
    }

    //divisionLevel validation
    if (fieldname === undefined || fieldname === "divisionLevel") {
      if (fieldname === undefined) {
        fieldValue = fields["divisionLevel"] ? fields["divisionLevel"] : "";
        updatedValue = fieldValue;
      }
      delete errorsT["divisionLevel"];
      if (!updatedValue) {
        // formIsValid = true;
        errorsT["divisionLevel"] = "";
      } else if (!AplhaNumericInputComma(updatedValue)) {
        formIsValid = false;
        errorsT["divisionLevel"] = "No Special Characters Allowed";
      }
    }
    // city validations
    if (fieldname === undefined || fieldname === "city") {
      if (fieldname === undefined) {
        fieldValue = fields["city"] ? fields["city"] : "";
        updatedValue = fieldValue;
      }
      delete errorsT["city"];
      if (!updatedValue) {
        // formIsValid = true;
        errorsT["city"] = "";
      } else if (!AplhaNumericInput(updatedValue)) {
        formIsValid = false;
        errorsT["city"] = "No Special Characters Allowed";
      }
    }

    // websiteURL
    if (fieldname === undefined || fieldname === "websiteURL") {
      if (fieldname === undefined) {
        fieldValue = fields["websiteURL"] ? fields["websiteURL"] : "";
        updatedValue = fieldValue;
      }
      delete errorsT["websiteURL"];
      if (!updatedValue) {
        // formIsValid = true;
        errorsT["websiteURL"] = "";
      } else if (!validURL(updatedValue)) {
        formIsValid = false;
        errorsT["websiteURL"] = "Please Enter a valid URL";
      }
    }

    //validation EndDate should be less then startDate
    if (fieldname === undefined || fieldname === "endDate") {
      if (fieldname === undefined) {
        fieldValue = fields["endDate"] ? fields["endDate"] : "";
        updatedValue = fieldValue;
      }
      delete errorsT["endDate"];
      if (!updatedValue) {
        formIsValid = false;
        errorsT["endDate"] = "Please enter the End Date of the Event";
      } else if (fields.endDate < fields.startDate) {
        formIsValid = false;
        errorsT["endDate"] = "End Date can't be less than the Start Date";
      }
    }

    //validation StartDate
    if (fieldname === undefined || fieldname === "startDate") {
      if (fieldname === undefined) {
        fieldValue = fields["startDate"] ? fields["startDate"] : "";
        updatedValue = fieldValue;
      }
      delete errorsT["startDate"];
      if (!updatedValue) {
        formIsValid = false;
        errorsT["startDate"] = "Please enter the Start Date of the Event";
      }
    }

    //validation eventname
    if (fieldname === undefined || fieldname === "eventName") {
      if (fieldname === undefined) {
        fieldValue = fields["eventName"] ? fields["eventName"] : "";
        updatedValue = fieldValue;
      }
      delete errorsT["eventName"];
      if (!updatedValue) {
        formIsValid = false;
        errorsT["eventName"] = "Please enter the Event Name";
      }
    }

    //validation category
    if (fieldname === undefined || fieldname === "category") {
      if (fieldname === undefined) {
        fieldValue = fields["category"] ? fields["category"] : "";
        updatedValue = fieldValue;
      }
      delete errorsT["category"];
      if (!updatedValue) {
        formIsValid = false;
        errorsT["category"] = "Please enter the Category";
      }
    }

    setErrors({
      ...errorsT,
    });
    return {
      formIsValid,
      updatedValue,
    };
  };

  const handleOrganizationsDropDownChange = (e, field) => {
    props.getAllOrganizationsList({
      query: getAllOrganizationsQuery,
      variables: {
        where: {
          active: 1,
          and: [
            {
              or: [
                {
                  eventOrganisation: {
                    like: `%${e.target.value}%`,
                    options: "i",
                  },
                },
              ],
            },
          ],
        },
      },
    });
    let fieldsT = fields;
    fieldsT["eventOrgName"] = e ? (e.target ? e.target.value : e) : e;
    setFields({
      ...fieldsT,
    });
  };

  const handleTeamsDropDownChange = (e, field) => {
    props.getAllTeamsList({
      query: getAllTeamsNameQuery,
      variables: {
        where: {
          active: 1,
          and: [
            {
              or: [
                {
                  teamName: { like: `%${e.target.value}%`, options: "i" },
                },
              ],
            },
          ],
        },
      },
    });
    let fieldsT = fields;
    fieldsT["eventTeamName"] = e ? (e.target ? e.target.value : e) : e;
    setFields({
      ...fieldsT,
    });
  };

  const IfAddedOtherOrganisation = async () => {
    if (fields?.eventOrganisation?.id == null) {
      let status = false
      const variables = {
        obj: {
          eventorgname: fields.eventOrgName,
        },
      };
      let res = await fetchGraphMethod(
        saveAllOrganizationsData,
        variables,
        true
      );
      if (
        res.data &&
        res.data.data &&
        res.data.data.saveOrganization &&
        res.data.data.saveOrganization.length != 0
      ) {
        let fieldsT = fields;
        fieldsT["eventOrganisation"] = res.data.data.saveOrganization;
        setFields({
          ...fieldsT,
        });
        status = true
      }else{
        status = false
      }
      return status
    }
  };

  const isEditAddedOtherOrganisation = async () => {
      let status = false
      const variables = {
        obj: {
          eventorgname: fields.eventOrgName,
        },
      };
      let res = await fetchGraphMethod(
          saveAllOrganizationsData,
          variables,
          true
      );
      if (
          res.data &&
          res.data.data &&
          res.data.data.saveOrganization &&
          res.data.data.saveOrganization.length != 0
      ) {
        let fieldsT = fields;
        fieldsT["eventOrganisation"] = res.data.data.saveOrganization;
        setFields({
          ...fieldsT,
        });
        status = true
      }else{
        status = false
      }
      return status
  };

  const isAddedOtherTeam = async () => {
    let status = false
      const variables = {
        obj: {
          teamname: fields.eventTeamName,
        },
      };

      let teamResponse = await fetchGraphMethod(
          saveAllTeamsDataQuery,
          variables,
          true
      );

      if (!!teamResponse.data.data.saveTeam) {
        let fieldsT = fields;
        fieldsT["teamName"] = teamResponse.data.data.saveTeam;
        setFields({
          ...fieldsT,
        });
        status = true
      }else{
        status = false
      }
    return status
  };


  const ifAddedOtherTeam = async () => {
    let status = false
    if (!fields?.teamName?.id) {
      const variables = {
        obj: {
          teamname: fields.eventTeamName,
        },
      };

      let teamResponse = await fetchGraphMethod(
        saveAllTeamsDataQuery,
        variables,
        true
      );

      if (!!teamResponse.data.data.saveTeam) {
        let fieldsT = fields;
        fieldsT["teamName"] = teamResponse.data.data.saveTeam;
        setFields({
          ...fieldsT,
        });
        status = true
      }else{
        status = false
      }
    }
    return status
  };

  const routeNextPage = () => {
    //this check is used for conditional routing
    if(props && props?.data?.location?.previousPage == "checklist"){
      setTimeout(()=>{
        dispatch({type:"RENDER_COUNT_START", payload: 1})
        history.push("/checklist");
      },300)
    }else {
      dispatch({type:"RENDER_COUNT_START", payload: 1})
      //this si code is commented as we dont want to redirect the page on event listing
      setTimeout(()=>{
        history.push("/events");
      },300)
    }
  };

  const saveAddEditFormData = async () => {
    setLoading(false);
    let eveStatus = false
    const variables =
      fields.eventId == ""
        ? {
          obj: {
            userid: getUserInfo() ? getUserInfo().id : 0,
            createdby: getUserInfo() ? getUserInfo().id : 0,
            categoryid: parseInt(fields.category),
            startdate: fields.startDate,
            enddate: fields.endDate,
            eventname: !!fields.eventName ? fields.eventName?.toUpperCase() ?? "" : "",//event name to UpperCase as per Discuss 30/11/2022
            divisionorlevel: fields.divisionLevel,
            location: fields.location,
            city: fields.city,
            stateid: parseInt(fields.state),
            stateinitial: fields.state ? props.data.allStates.data.filter(item => item.id == fields.state)[0].statename : null,
            countryid: parseInt(fields.countryId ? fields.countryId : null),
            eventwebsiteurl: fields.websiteURL,
            eventnotes: fields.eventNotes,
            eventorgid: fields.eventOrganisation
              ? parseInt(fields.eventOrganisation.id)
              : null,
            teamid: fields.teamName ? parseInt(fields.teamName.id) : null,
          },
        }
        : {
          obj: {
            id: fields.eventId,
            isedit: 1,
            userid: getUserInfo() ? getUserInfo().id : 0,
            createdby: getUserInfo() ? getUserInfo().id : 0,
            categoryid: parseInt(fields.category),
            startdate: fields.startDate,
            enddate: fields.endDate,
            eventname: !!fields.eventName ? fields.eventName?.toUpperCase() ?? "" : "",//event name to UpperCase as per Discuss 30/11/2022
            divisionorlevel: fields.divisionLevel,
            location: fields.location,
            city: fields.city,
            stateid: parseInt(fields.state),
            countryid: parseInt(fields.countryId ? fields.countryId : null),
            eventwebsiteurl: fields.websiteURL,
            eventnotes: fields.eventNotes,
            isverified:fields.isverified,
            eventorgid: fields.eventOrganisation
              ? parseInt(fields.eventOrganisation.id)
              : null,
            teamid: fields.teamName ? parseInt(fields.teamName.id) : null,
          },
        };

    let addEditEventResponse = await fetchGraphMethod(
      saveAddEditEventFormData,
      variables,
      true
    );
    if (addEditEventResponse.data.data.saveEvent) {
      toastr.success(`Your event is ${!!fields.eventId ? "updated" : "saved"} successfully`, "",{
        progressBar : true,timeOut: 2000,
        closeButton: true, positionClass: "toast-top-full-width",
        showEasing: "swing", fadeIn: 40000,
        preventDuplicates: true,
      })
      // messagePopup("", `Your event is ${!!fields.eventId ? "updated" : "saved"} successfully`, "success");
      let fieldsT = fields;
      fieldsT["eventId"] = addEditEventResponse.data.data.saveEvent;
      setFields({
        ...fieldsT,
      });
      eveStatus = true
      routeNextPage()
    } else if (addEditEventResponse.data.errors) {
      messagePopup(
        "",
        addEditEventResponse.data.errors[0].message.msg,
        "warning"
      );
      eveStatus = false
    }
    return eveStatus
  };

  const AddEvent = async () => {
    const { formIsValid } = handleValidation();
    if (formIsValid) {
      setLoading(true)
      let eventStatus = false
      const orgCheck = !!fields?.eventOrganisation?.id ? false : !!fields?.eventOrgName ? true :
          (!!fields?.eventOrganisation?.id || !!fields?.eventOrgName) ? true : false
      if (orgCheck) {
        const orgStatus = await IfAddedOtherOrganisation();
        if(!orgStatus) {
          setLoading(false)
          return messagePopup("", "Organization with same name already exists. Not available " +
              "in search section due to pending verification", "warning")

        }else{
          eventStatus = true
        }
      }else {
        eventStatus = true
      }
      const teamCheck = !!fields?.teamName?.id ? false :  !!fields?.eventTeamName ? true :
          (!!fields?.teamName?.id || !!fields?.eventTeamName) ? true : false
      if (teamCheck) {
        const teamOrg = await ifAddedOtherTeam();
        if(!teamOrg){
          setLoading(false)
          return  messagePopup("","Team with same name already exists. " +
              "Not available in search section due to pending verification","warning")
        }else{
          eventStatus = true
        }
      }else {
        eventStatus = true
      }
      if(eventStatus){
       const eveStatus =  await saveAddEditFormData();
       if(!eveStatus){
         setLoading(false)
         return
       }
        const variables = {
          obj: {
            eventid: fields.eventId ? +(fields.eventId.id) : null,
            addedby: getUserInfo() ? getUserInfo().id : 0,
            createdby: getUserInfo() ? getUserInfo().id : 0,
          },
        };

        let addedEventResponse = await fetchGraphMethod(
            saveAddedEventQuery,
            variables,
            true
        );
        if (addedEventResponse) {
          setLoading(false)
        }
        routeNextPage();
      }
    }
  };

  const UpdateEvent = async () => {
    const { formIsValid } = handleValidation();
    if (formIsValid) {
      let updateEvent = false
      const orgCheck = (!!fields?.eventOrganisation?.id && (fields?.eventOrgName == fields?.eventOrganisation?.eventorgname)) ? false : !!fields?.eventOrgName ? true :
          (!!fields?.eventOrganisation?.id || !!fields?.eventOrgName) ? true : false
      if (orgCheck){
          const orgStatus  = await isEditAddedOtherOrganisation();
          if(!orgStatus){
            setLoading(false);
            return   messagePopup("","Organization with same name already exists. Not available " +
                "in search section due to pending verification","warning")
          }
          updateEvent = true
      }else{
        updateEvent = true
      }
      const teamCheck = (!!fields?.teamName?.id && (fields?.eventTeamName == fields?.teamName?.teamname)) ? false :  !!fields?.eventTeamName ? true :
          (!!fields?.teamName?.id || !!fields?.eventTeamName) ? true : false
      if (teamCheck) {
          const teamStatus = await isAddedOtherTeam();
          if(!teamStatus){
            setLoading(false);
            messagePopup("","Team with same name already exists. Not available " +
                "in search section due to pending verification","warning")
            return
          }
             updateEvent = true
      }else{
        updateEvent = true
      }
      if(updateEvent){
        await saveAddEditFormData();
        // routeNextPage();
      }
    }
  };
  return (
    <div className="editSection">
      
      <Title title={"Events"} />
      <BackdropLoader open={loading} />
      <div className="check-list-sec">
        <div className="editprofile-common-form team-common-form">
          <form className="coches-request-wrap">
            <h3>Add / Edit Upcoming Event</h3>
            <div className="connect-with-coaches-top-box"></div>
            <div className="fieldBox flexBox">
              <div className="half">
                <label style={styleSheet}>Category <sup>*</sup></label>
                <FormControl variant="outlined" fullWidth>
                  <Select
                    onChange={(e) => handleChange(e, "category")}
                    // labelId="category"
                    id="category"
                    name="category"
                    value={fields.category || ""}
                    // label="Select"
                    displayEmpty
                  >
                    <MenuItem value="">
                      <em>Select</em>
                    </MenuItem>

                    {props.data &&
                      props.data.allCategories &&
                      props.data.allCategories.data &&
                      props.data.allCategories.data.data.allEventcategories &&
                      props.data.allCategories.data.data.allEventcategories
                        .Eventcategories
                      ? props.data.allCategories.data.data.allEventcategories.Eventcategories.map(
                        (item, index) => (
                          <MenuItem key={index} value={item.id || ""}>
                            {item.categoryname}
                          </MenuItem>
                        )
                      )
                      : ""}
                  </Select>
                </FormControl>
                <div className="error">{errors["category"]}</div>
              </div>
              <div className="half">
                <label>Start Date <sup>*</sup></label>
                <input
                  type="date"
                  value={fields.startDate || ""}
                  onChange={(e) => handleChange(e, "startDate")}
                  placeholder="mm/dd/yyyy"
                  max="9999-12-31"
                />
                <div className="error">{errors["startDate"]}</div>
              </div>
            </div>
            <div className="fieldBox flexBox">
              <div className="half">
                <label>End Date<sup>*</sup></label>
                <input
                  type="date"
                  value={fields.endDate || ""}
                  onChange={(e) => handleChange(e, "endDate")}
                  placeholder="mm/dd/yyyy"
                  max="9999-12-31"
                />
                <div className="error">{errors["endDate"]}</div>
              </div>
              <div className="half">
                <label>Event Name<sup>*</sup></label>
                <input
                  value={fields.eventName || ""}
                  onChange={(e) => handleChange(e, "eventName")}
                  type="text"
                  placeholder="Event Name"
                />
                <div className="error">{errors["eventName"]}</div>
              </div>
            </div>
            <div className="fieldBox flexBox">
              <div className="half">
                <label>Event Organization</label>
                <div className={'eventAuto-wrapper'}>
                <MuiAutoComplete
                  id="free-solo-demo"
                  freeSolo={true}
                  options={eventOrganisationArray}
                  getOptionLabel={(option) =>
                    option.eventorgname ? option.eventorgname : ""
                  }
                  value={fields.eventOrganisation || ""}
                  onChange={(event, newValue) => {
                    handleOrganizationsDropDownChange(
                      { target: { value: newValue } },
                      "eventOrganisation"
                    );
                  }}
                  onChangeObj={(e, newValue) => {
                    handleChange(
                      {
                        target: { value: newValue },
                      },
                      "eventOrganisation"
                    );
                  }}
                  inputPlaceholder="Event Organization"
                />
                </div>
              </div>
              <div className="half">
                <label>Team / Program</label>
                <div className={'eventAuto-wrapper'}>
                <MuiAutoComplete
                  id="teamName"
                  freeSolo={true}
                  options={teamProgramArray}
                  getOptionLabel={(option) =>
                    option.teamname ? option.teamname : ""
                  }
                  value={fields.teamName || ""}
                  onChange={(event, newValue) => {
                    handleTeamsDropDownChange(
                      { target: { value: newValue } },
                      "teamName"
                    );
                  }}
                  onChangeObj={(event, newValue) => {
                    handleChange({ target: { value: newValue } }, "teamName");
                  }}
                  inputPlaceholder="Team Name"
                />
                </div>
              </div>
            </div>
            <div className="fieldBox flexBox">
              <div className="half">
                <label>Division / Level</label>
                <input
                  value={fields.divisionLevel || ""}
                  onChange={(e) => handleChange(e, "divisionLevel")}
                  type="text"
                  placeholder="e.g. 16U, Grad Year, Majors"
                />
                <div className="error">{errors["divisionLevel"]}</div>
              </div>
              <div className="half">
                <label>Location</label>
                <input
                  value={fields.location || ""}
                  onChange={(e) => handleChange(e, "location")}
                  type="text"
                  placeholder="Sports Complex"
                />
                <div className="error">{errors["location"]}</div>
              </div>
            </div>
            <div className="fieldBox flexBox">
              <div className="half">
                <label>City</label>
                <input
                  value={fields.city || ""}
                  onChange={(e) => handleChange(e, "city")}
                  type="text"
                  placeholder="City"
                />
                <div className="error">{errors["city"]}</div>
              </div>
              <div className="half">
                <span style={styleSheet}>State</span>

                <FormControl variant="outlined" fullWidth>
                  <Select
                    // labelId="demo-simple-select-outlined-label"
                    // id="demo-simple-select-outlined"
                    value={parseInt(fields.state) || ""}
                    onChange={(e) => {
                      handleChange(e, "state");
                      getCountryId();
                    }}
                    // label="Select"
                    displayEmpty
                  >
                    <MenuItem value="">Select</MenuItem>
                    <ListSubheader
                      style={{ position: "relative", pointerEvents: "none" }}
                    >
                      United States
                    </ListSubheader>
                    {props.data.allStates.data &&
                      props.data.allStates.data.map((item, index) => {
                        if (item.countryid == 1) {
                          return (
                            <MenuItem key={index} value={item.id || ""}>
                              {item.initials}
                            </MenuItem>
                          );
                        }
                      })}
                    <ListSubheader
                      style={{ position: "relative", pointerEvents: "none" }}
                    >
                      Canada
                    </ListSubheader>
                    {props.data.allStates.data &&
                      props.data.allStates.data.map((item, index) => {
                        if (item.countryid == 2) {
                          return (
                            <MenuItem key={index} value={item.id || ""}>
                              {item.initials}
                            </MenuItem>
                          );
                        }
                      })}
                  </Select>
                </FormControl>
              </div>
            </div>
            <div className="fieldBox flexBox">
              {fields.state != "" && fields.countryId != 1 && (
                <div className="half">
                  <label>Country</label>
                  <input
                    value={fields.country || ""}
                    onChange={(e) => handleChange(e, "country")}
                    type="text"
                    placeholder="Country"
                    disabled
                  />
                </div>
              )}

              <div className="half">
                <label>Event Website Link</label>
                <input
                  value={fields.websiteURL || ""}
                  onChange={(e) => handleChange(e, "websiteURL")}
                  type="url"
                  placeholder="Enter your event website link"
                />
                <div className="error">{errors["websiteURL"]}</div>
              </div>
            </div>
            <div className="fieldBox full">
              <label>Event Notes</label>
              <textarea
                value={fields.eventNotes || ""}
                onChange={(e) => handleChange(e, "eventNotes")}
                maxLength="200"
                placeholder=" E.G. Add specific schedule, field #'s, playing time, jersey #, etc... (Max 200 Characters)"
              ></textarea>
              <div className="error">{errors.eventNotes}</div>
            </div>
            <div className="invite-coach-wrap">
              <div className="button-box">
                {fields.eventId == "" ? (
                  <Link className="btn orange" to="/events/add-event">
                    Back
                  </Link>
                ) : (
                  <Link className="btn orange" to="/events">
                    Back
                  </Link>
                )}

                {fields.eventId == "" ? (
                  <a href={void 0} className="btn green" onClick={(e) => AddEvent(e)}>
                    Add Event
                  </a>
                ) : (
                  <a href={void 0} className="btn green" onClick={(e) => UpdateEvent(e)}>
                    Update Event
                  </a>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

const AddEditEventForm = (props) => {
  const store = useSelector(store => store)
  const [sideMenuOpen, setSideMenu] = useState(store?.athlete?.editUserProfileData?.eventSideBarStatus?.status || false);
  const dispatch = useDispatch()
  const onSideMenuClick = () => {
    setSideMenu(!sideMenuOpen);
    //func of redux
    dispatch({type:"EVENT_SIDE_BAR_START", payload: {status: !sideMenuOpen}})
  };

  useEffect(() => {
    getAllStatesList();
    getAllCountriesList();
    props.categoriesListStart({
      query: getAllEventCatergoriesQuery,
      variables: null,
    });
    getAllEventsDataList();
    getAllOrganizationsList();
    getAllTeamsList();
  }, []);

  const getAllEventsDataList = () => {
    let eventId = window.location.href.split("/")[5];//$ earlier it was 6 before BR
    props.addEditEventFormListStart({
      query: getAllAddEditFormDataQuery,
      variables: {
        obj: {
          id: eventId,
        },
      },
    });
  };
  const getAllStatesList = () => {
    props.stateListStart({
      query: getAllStatesCountries,
    });
  };

  const getAllCountriesList = () => {
    props.countryListStart({
      query: getAllCountriesQuery,
      variables: null,
    });
  };

  const getAllOrganizationsList = () => {
    props.organizationsListStart({
      query: getAllOrganizationsQuery,
      variables: null,
    });
  };

  const getAllTeamsList = () => {
    props.allTeamsListStart({
      query: getAllTeamsNameQuery,
      variables: null,
    });
  };
  //this is used for scrolling the page on top
  useEffect(()=>{
    window.scrollTo(0,0)
  })

  return (
    <div className="pageContent">
      <div className="editProfile">
        <div className="container">
          <div
            id="wrapper"
            className={`flex ${sideMenuOpen ? "inactive" : ""}`}
          >
            <SubHeader onSideMenuClick={onSideMenuClick} />
            <div className="sidebar">
              <LeftSideEditProfile />
            </div>

            <EditSection
              data={props}
              eventName={props.history.location.state?.eventName}
              eventOrgName={props.history.location.state?.eventOrg}
              city={props.history.location.state?.city}
              state={props.history.location.state?.state}
              singleData={props.addEditEventFormList}
              getAllEventsDataList={getAllEventsDataList}
              getAllOrganizationsList={getAllOrganizationsList}
              getAllTeamsList={getAllTeamsList}
              getAllStatesList={getAllStatesList}
              getAllCountriesList={getAllCountriesList}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    addEditEventFormList:
      state.athlete.editUserProfileData.addEditEventFormList.data,
    addedEvents: state.athlete.editUserProfileData.addAddedEvent,
    allStates: state.common.states,
    allCountries: state.common.countries,
    allOrganizations: state.common.organizations,
    allCategories: state.common.categories,
    teamList: state.athlete.editUserProfileData.teamsList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addEditEventFormListStart: (data) =>
      dispatch(addEditEventFormListStart(data)),
    stateListStart: (data) => dispatch(stateListStart(data)),
    countryListStart: (data) => dispatch(countryListStart(data)),
    organizationsListStart: (data) => dispatch(organizationsListStart(data)),
    organizationsSaveStart: (data) => dispatch(organizationsSaveStart(data)),
    categoriesListStart: (data) => dispatch(categoriesListStart(data)),
    allTeamsListStart: (data) => dispatch(allTeamsListStart(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddEditEventForm);
